import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useUsers } from "../../Context/UsersContext";
import style from "../../assets/jss/disal-main/Layouts/Gerencia";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import ModalDelete from "../../Component/Modal/ModalDeleteUser";
import ModalSuccess from "../../Component/Modal/ModalExitoUser";
import FormUser from "../../Component/Form/User";


const useStyles = makeStyles(style);

const UsersContent = () => {
  const miningSites = JSON.parse(localStorage.getItem('miningSites'));
  const classes = useStyles();

  const { 
    miningSite,
    setMiningSite,
    selected,
    setSelected,
    nameFilter,
    setNameFilter,
    idFilter,
    setIdFilter,
    dniFilter,
    setDniFilter,
    users,
    operatorTypes,
    typeFilter,
    setTypeFilter,
    setDeleteItem,
  } = useUsers();

  const filterDisabled = miningSite === 0;

  const handleClickUser = (item) => {
    setSelected(item);
  };

  return (
    <div className={classes.content}>
      <Grid container className={classes.gerencia}>
        <Grid item xs={12} className={classes.filter}>
          <FormControl
            variant="outlined"
          >
            <Select
              className={classes.filterSelectSmall}
              value={miningSite}
              onChange={(e) => {
                setMiningSite(e.target.value);
              }}
            >
              <MenuItem value={0}>Seleccione una planta</MenuItem>
              {miningSites.map((res, key) => {
                return (
                  <MenuItem key={key} value={res.id}>
                    {res.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <FormControl
            variant="outlined"
          >
            <Paper className={classes.filterInput}>
              <InputBase
                className={classes.input}
                disabled={filterDisabled}
                value={idFilter}
                placeholder="Buscar por id"
                onChange={(e) => setIdFilter(e.target.value)}
              />
              <IconButton
                type="button"
                className={classes.iconButton}
                disabled={filterDisabled}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
            </Paper>
          </FormControl>
          <FormControl
            variant="outlined"
          >
            <Paper className={classes.filterInputSmall}>
              <InputBase
                className={classes.input}
                disabled={filterDisabled}
                value={nameFilter}
                placeholder="Buscar por nombre"
                onChange={(e) => setNameFilter(e.target.value)}
              />
              <IconButton
                type="button"
                className={classes.iconButton}
                disabled={filterDisabled}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
            </Paper>
          </FormControl>
          <FormControl
            variant="outlined"
          >
            <Paper className={classes.filterInputSmall}>
              <InputBase
                className={classes.input}
                disabled={filterDisabled}
                value={dniFilter}
                placeholder="Buscar por dni"
                onChange={(e) => setDniFilter(e.target.value)}
              />
              <IconButton
                type="button"
                className={classes.iconButton}
                disabled={filterDisabled}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
            </Paper>
          </FormControl>
          <FormControl
            variant="outlined"
          >
            <Select
              className={classes.filterSelectSmall}
              disabled={filterDisabled}
              value={typeFilter}
              placeholder="Buscar por tipo"
              onChange={(e) => setTypeFilter(e.target.value)}
            >
              <MenuItem value={0}>Seleccione una opción</MenuItem>
              {operatorTypes.map((item, index) => (
                <MenuItem key={index} value={item.id}>
                  {item.description}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={4} className={classes.listAdd}>
          <h3 className={classes.title}>Lista de Usuarios</h3>
          <List className={classes.listGerencia}>
            {users.map((item, index) => (
              <ListItem
                button
                id={item.operatorId}
                className={
                  classes.Listbutton +
                  (selected && selected.operatorId === item.operatorId ? " active-item" : null)
                }
                onClick={() => handleClickUser(item)}
                key={index}
              >
                <ListItemText primary={item.name} />
                {selected && selected.operatorId === item.operatorId ? (
                  <button
                    id={item.operatorId}
                    className={classes.iconClose}
                    onClick={() => setDeleteItem(item)}
                  >
                    <CloseIcon />
                  </button>
                ) : null}
              </ListItem>
            ))}
          </List>
          {miningSite === 0 ? null : (
            <button
              className={classes.iconMore}
              onClick={() => setSelected({
                operatorId: "",
                password: "",
                dni: "",
                name: "",
                operatorTypeId: 0
              })}
            >
              <AddIcon />
            </button>
          )}
        </Grid>
        <Grid item xs={8} className={classes.formGerencia}>
          <h3 className={classes.title}>Datos del Usuario</h3>
          {selected ? (
            <FormUser />
          ) : (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              No hay usuario seleccionado
            </div>
          )}
        </Grid>
      </Grid>
      <ModalDelete />
      <ModalSuccess />
    </div>
  );
}

export default UsersContent;
